import type { IDrawerProps } from '../../types/drawer';
import { Modal } from '../Modal';

import styles from './drawer.module.scss';

export const Drawer = ({
  position = 'inline-end',
  wrapperClassName,
  size,
  children,
  ...rest
}: IDrawerProps) => {
  const isHorizontal = ['inline-start', 'inline-end'].includes(position);
  const drawerWidth = isHorizontal ? size || '35rem' : '100%';
  const drawerHeight = !isHorizontal ? size || '25rem' : '100%';

  return (
    <Modal
      {...rest}
      wrapperClassName={
        `${styles['drawer']} ${styles[`drawer--${position}`]}` +
        (wrapperClassName ? ` ${wrapperClassName}` : '')
      }
      customStyles={{ width: drawerWidth, height: drawerHeight }}
    >
      <div className={styles['drawer__content']}>{children}</div>
    </Modal>
  );
};
